enum CodeTypeEnum {
    Code = 'CODE',
    NonCode = 'NON_CODE',
}

export default CodeTypeEnum;
